import { Section } from '@/domain/Section'
import axios from 'axios'

/**
 * 部署サービス
 */
export default class SectionsService {
    /** インスタンス */
    private static _instance: SectionsService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new SectionsService();
        }
        return this._instance;
    }
    
    /**
     * 新規作成
     */
    public async createNew(): Promise<Section> {
        return await axios.get("/api/section/new")
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }
    
    /**
     * 編集
     */
    public async edit(no: string): Promise<Section> {
        return await axios.get(`/api/section/edit/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 新規保存
     */
    public async create(dto: Section): Promise<Section> {
        return await axios.post("/api/section/new", dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 保存
     */
    public async update(dto: Section): Promise<Section> {
        return await axios.put(`/api/section/edit/${dto.code}`, dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 部署一覧を検索
     */
    public async findAll(): Promise<Section[]> {
        return await axios.get("/api/sections")
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Section[]).map(x => this.convert(x))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 受信データの変換
     * @param data
     */
    // eslint-disable-next-line
    private convert(data: any): Section {
        const section = data as Section
        return new Section({ ...section })
    }
}
